module.exports = __webpack_public_path__ + "static/media/abacusStudents.ecb96b6f.jpeg";